import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractNavigationService } from '../../services';
import { GenreViewModel } from './genre-list.view-model';

@Component({
  selector: 'osn-shared-genre-list',
  templateUrl: './genre-list.component.html',
  styleUrls: ['./genre-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenreListComponent {
  @Input() public genres: GenreViewModel[];
  @Input() public darkTextColor = false;
  @Output() public genreClickEvent: EventEmitter<string> = new EventEmitter();

  public constructor(private readonly navigationService: AbstractNavigationService) {}

  public getRouteUrl(genre: string): string {
    return this.navigationService.getUrl('browseGenre', genre.toLowerCase());
  }

  public onGenreClick(genre: GenreViewModel): void {
    this.genreClickEvent.emit(genre.en);
  }
}
